import { useIntl } from 'gatsby-plugin-react-intl'

export function useTranslate(baseRef) {
  const intl = useIntl()
  const t = (key) => intl.formatMessage({ id: `${baseRef}.${key}` })
  return {
    t
  }
}
